import React, { useContext, useMemo, useState } from 'react';
import StoreProductView from '../StoreProductView/StoreProductView';
import { t } from '../../../../common/components/T';
import { LangContext } from '../../../../common/decorators/Language';
import Store from '../../../../layouts/store/Store/Store';
import css from './StoreProductWrapper.module.scss';
import { replaceUrl } from '../../../../common/utils/router';
import { useRouter } from 'next/router';
import UserContext from '../../../../common/utils/getContext';

const StoreProductWrapper = ({ cartData, product, translates, categories, loadMoreCategories }) => {
    const { translation } = useContext(LangContext) || {};
    const { routerLoader } = useContext(UserContext);
    const breadcrumbs = useMemo(
        () => [
            {
                title: t('mainPageTitle', 'Главная', 'all', translation),
                link: `/`
            },
            {
                title: t('storePageTitle', 'Магазин', 'all', translation),
                link: '/store'
            },
            ...(product?.breadcrumbs.map((elem) => ({
                title: elem.name,
                link: `/store/category/${elem.url || elem.id}`
            })) || []),
            {
                title: product?.name,
                link: `/store/product/${product?.id}`
            }
        ],
        [product, translation]
    );
    const router = useRouter();

    const disabledParentTransition =
        product?.status !== 'deleted' &&
        routerLoader &&
        routerLoader?.from?.includes(`/store/product/${product?.id}`) &&
        routerLoader?.to?.includes(`/store/product/${product?.id}`);

    const [productWithCurrency, setProductWithCurrency] = useState(null);

    return (
        <Store
            disabledTransition={disabledParentTransition}
            seoData={{
                seo_title: productWithCurrency?.seo_title || productWithCurrency?.name,
                seo_description: productWithCurrency?.seo_description,
                seo_keywords: productWithCurrency?.seo_keywords,
                image: productWithCurrency?.image?.links?.preview
            }}
            canonical={replaceUrl(`/${`store/product/${product?.id}`}`, router)}
            cartData={cartData}
            categories={categories}
            loadMoreCategories={loadMoreCategories}
            title={productWithCurrency?.name}
            translates={translates}
            breadcrumbs={productWithCurrency?.status === 'deleted' ? [] : breadcrumbs}
            OverFooter={() => (
                <>
                    {/*<Reviews setStats={setStats} product={product} reviews={reviewsData} setReviewsData={setReviewsData}>*/}
                    {/*    {children}*/}
                    {/*</Reviews>*/}
                </>
            )}
            compStyles={css}
        >
            <StoreProductView
                productWithCurrency={productWithCurrency}
                prodId={product?.id}
                setProductWithCurrency={setProductWithCurrency}
            />
        </Store>
    );
};
export default StoreProductWrapper;
